"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const theme_1 = require("@zapier/theme");
const ruleGroupHeaderContainer = core_1.css `
  margin-bottom: ${theme_1.Spacing.small}px;
`;
const RuleGroupHeader = ({ isFirst }) => (core_1.jsx("div", { css: ruleGroupHeaderContainer },
    core_1.jsx(design_system_1.Text, { fontWeight: 600, type: "altText800" }, isFirst ? 'Only continue if…' : 'OR continue if…')));
exports.default = RuleGroupHeader;
